'use client';

import { useSearchParams } from 'next/navigation';

import { useGlobalCmsContentContext } from '../../components/providers/global-cms-context';
import { usePathname, useRouter } from '../../i18n/i18n-navigation';

export const useLanguageSwitcher = () => {
  const router = useRouter();
  const { cmsPaths } = useGlobalCmsContentContext();
  const pathname = usePathname();
  const searchParameters = useSearchParams();

  const parameters = new URLSearchParams(searchParameters);
  const newPathWithSearchParameters = parameters.toString()
    ? `${pathname}?${parameters.toString()}`
    : pathname;

  const shouldResetSearchParameters = pathname === cmsPaths.searchPagePath; // this is a workaround for the search page, where we need to reset the search parameters when changing the language

  const onLanguageChange = (locale: string) => {
    router.replace(shouldResetSearchParameters ? pathname : newPathWithSearchParameters, {
      locale,
    });
  };

  return { onLanguageChange };
};
